<template>
    <div>
        <div>
            <div v-if="!readonly">
                <tinymce
                    id="HtmlTextArea"
                    v-bind:model-value="messageBody"
                    v-bind:init="tinymceInit"
                    v-on:change="onMessageBodyChanged"
                    v-on:update:model-value="onInput" />
            </div>
            <div v-else>
                <div class="p-3 border rounded readonly-communication-content-border">
                    <!--
                        Using a v-html directive to display contents rather than a
                        disabled tinymce instance because in that case, text is not selectable and
                        links aren't clickable. The HTML content has already been scrubbed by the
                        server by this point so this shouldn't be a security concern
                    -->
                    <!-- eslint-disable vue/no-v-html -->
                    <div
                        id="CommunicationContent"
                        class="readonly-communication-content"
                        v-html="messageBody" />
                    <!-- eslint-enable vue/no-v-html -->
                </div>
            </div>
        </div>
        <div
            v-if="messageBodyContentError"
            class="row">
            <validation-render-helper
                class="mt-0"
                v-bind:validation-error="messageBodyContentError" />
        </div>
    </div>
</template>
<script>
    import tinymce from "@tinymce/tinymce-vue";
    import { TINYMCE_DEFAULTS } from "Util/tinymceDefaults";
    import validationRenderHelper from "Validation/_validation-error-helper.vue";
    import { NAMESPACE, KEYS } from "./i18n/communicationContent.i18n";
    import { mapI18n } from "Util/i18n";

    export default {
        components: {
            tinymce,
            validationRenderHelper
        },
        props: {
            messageBody: { type: String, required: false, default: null },
            readonly: { type: Boolean, required: false, default: false },
            tinymceOverrides: { type: Object, required: false, default: null }
        },
        emits: ["message-body-validated", "update:messageBody"],
        data() {
            return {
                messageBodyContentError: null
            };
        },
        computed: {
            tinymceInit() {
                return { ...TINYMCE_DEFAULTS, ...this.tinymceOverrides };
            },
            ...mapI18n(
                {
                    ...KEYS
                },
                NAMESPACE
            )
        },
        methods: {
            onMessageBodyChanged() {
                this.validate();
                this.$app.setUnsavedChanges(true);
            },
            onInput(newVal) {
                this.$emit("update:messageBody", newVal);
            },
            validate() {
                const htmlContent = this.messageBody;
                const domParser = new DOMParser();
                const doc = domParser.parseFromString(htmlContent, "text/html");
                if (doc && doc.documentElement && doc.documentElement.innerText.trim().length > 0) {
                    this.messageBodyContentError = null;
                } else {
                    this.messageBodyContentError = this.contentEmptyValidationErrorMessage;
                }
                this.$emit("message-body-validated", this.messageBodyContentError);
            }
        }
    };
</script>
<style lang="scss" scoped>
    .readonly-communication-content-border {
        border-width: 3px !important;
        border-color: var(--bs-gray-600);
    }

    .readonly-communication-content {
        min-height: 25vh;
    }
</style>
